import { render, staticRenderFns } from "./PTableRow.vue?vue&type=template&id=71b49f55&scoped=true"
import script from "./PTableRow.vue?vue&type=script&lang=js"
export * from "./PTableRow.vue?vue&type=script&lang=js"
import style0 from "./PTableRow.vue?vue&type=style&index=0&id=71b49f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b49f55",
  null
  
)

export default component.exports